import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const userList = createApi({
    reducerPath: 'userList',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
        prepareHeaders: (headers, { getState }) => {
            console.log(getState,'state check')
            // const token = getState()?.userAdminData?.token;
            const token = getState()?.posData?.token;
            console.log(token,'token check')
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getUserList: builder.query({
            query: ({ page, limit, search }) => {
                return {
                    url: `/get-users`,
                    method: 'GET',
                    params: {
                        page: page,
                        pageSize: limit,
                        search: search ?? ""
                    },
                }
            },
            // providesTags: ['UserList'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        addUpdateUser: builder.mutation({
            // query: ({body, id}) => {
            //     return {
            //         url: id !== undefined ? `user-add-update?id=${id}` : `user-add-update`,
            //         method: 'POST',
            //         body: body,
            //     }
            // },
            // invalidatesTags: ['UserList'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            // transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        deleteUser: builder.mutation({
            // query: (id) => {
            //     return {
            //         url: `user-delete?id=${id}`,
            //         method: 'DELETE',
            //     }
            // },
            // invalidatesTags: ['UserList'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            // transformErrorResponse: (error) => transformResponseHandler(error)
        }),
    }),
});

export const { useGetUserListQuery, useAddUpdateUserMutation, useDeleteUserMutation } = userList;